/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Page_EyebrowInputs */

const en_landing_pricing_page_eyebrow = /** @type {(inputs: Landing_Pricing_Page_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 4.5 pricing`)
};

const zh_landing_pricing_page_eyebrow = /** @type {(inputs: Landing_Pricing_Page_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 4.5 价格`)
};

/**
* | output |
* | --- |
* | "Ideogram 4.5 pricing" |
*
* @param {Landing_Pricing_Page_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_page_eyebrow = /** @type {((inputs?: Landing_Pricing_Page_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Page_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_page_eyebrow(inputs)
	return zh_landing_pricing_page_eyebrow(inputs)
});
export { landing_pricing_page_eyebrow as "landing.pricing.page_eyebrow" }